/*
 * Selection Elements Mixin
 * This mixin groups some common properties and methods for all selection elements of a form:
 * radio buttons, checkboxes and switch elements.
 */
import FormElement from '@/modules/form/mixins/form-element';

export default {
  mixins: [FormElement],

  data() {
    return {
      currentValue: {
        type: Boolean,
      },
    };
  },

  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  methods: {
    onChange(newValue) {
      this.$emit('input', newValue);
      this.$parentForm.updateField(this.name, this.currentValue);
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },

  mounted() {
    this.currentValue = this.value;
  },
};
